export default defineNuxtRouteMiddleware(async (to, from) => {
  const publicRoutes = [
    '/faqs',
    '/terms',
    '/privacy-policy',
    '/login',
    '/signup',
    '/reset-password',
    '/activate',
    '/manifest.webmanifest'
  ]
  const restrictedIfLoggedIn = [
    '/login',
    '/signup',
    '/reset-password',
    '/activate'
  ]

  const userStore = useUserStore();
  const isPublicPath = publicRoutes.some(path => to.path.startsWith(path));
  const shouldRedirectIfLoggedIn = restrictedIfLoggedIn.some(path =>
    to.path.startsWith(path)
  );

  // A user signing in with an admin-issued temporary password is sent to
  // /reset-password/<code> by the login action, which marks them logged in
  // first. Without this exemption the guard below bounces them to "/" and
  // they stay stuck on the temporary password.
  const isForcedPasswordReset =
    to.path.startsWith('/reset-password') &&
    !!userStore.user?.has_temporary_password;

  if (!userStore.isUserLoggedIn && !isPublicPath) {
    return navigateTo("/login");
  }

  if (userStore.isUserLoggedIn) {
    try {
      await jwtChecker();
    } catch {
      userStore.logout();
      return navigateTo("/login");
    }

    if (shouldRedirectIfLoggedIn && !isForcedPasswordReset) {
      return navigateTo("/");
    }
  }
});
